import type {LngLat} from '@logistics-frontend/blocks'

/**
 * На основе координат высчитывает левую верхнюю и нижнюю правую точку, которые служат определением видимой части карты.
 * @param coordinates Координаты тчоек, отображаемых на карте
 * @returns bounds - две точки на карте
 */
export const calculateBounds = (coordinates: LngLat[]): [LngLat, LngLat] => {
  if (coordinates.length < 2) {
    throw new Error('Для расчёта углов необходимо минимум две координаты')
  }

  // Инициализируем минимальные и максимальные значения первыми координатами
  let minLng = coordinates[0][0]
  let maxLng = coordinates[0][0]
  let minLat = coordinates[0][1]
  let maxLat = coordinates[0][1]

  // Проходим по всем координатам, обновляя минимальные и максимальные значения
  coordinates.forEach(([lng, lat]) => {
    if (lat < minLat) {
      minLat = lat
    }

    if (lat > maxLat) {
      maxLat = lat
    }

    if (lng < minLng) {
      minLng = lng
    }

    if (lng > maxLng) {
      maxLng = lng
    }
  })

  // Возвращаем левый верхний и правый нижний углы карты
  const topLeft: LngLat = [minLng, maxLat]
  const bottomRight: LngLat = [maxLng, minLat]

  return [topLeft, bottomRight]
}
